import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllVkosQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllVkosQuery = { __typename?: 'Query', vkos?: Array<{ __typename?: 'Vko', id: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, vkoUser: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null };

export type CreateVkoMutationVariables = Types.Exact<{
  input: Types.CreateVkoInput;
}>;


export type CreateVkoMutation = { __typename?: 'Mutation', createVko: { __typename?: 'CreateVkoPayload', vko?: { __typename?: 'Vko', id: string } | null } };

export type UpdateVkoMutationVariables = Types.Exact<{
  input: Types.UpdateVkoInput;
}>;


export type UpdateVkoMutation = { __typename?: 'Mutation', updateVko: { __typename?: 'UpdateVkoPayload', vko?: { __typename?: 'Vko', id: string } | null } };

export type DeleteVkoMutationVariables = Types.Exact<{
  input: Types.DeleteVkoInput;
}>;


export type DeleteVkoMutation = { __typename?: 'Mutation', deleteVko: { __typename?: 'DeleteVkoPayload', vko?: { __typename?: 'Vko', id: string } | null } };


export const GetAllVkosDocument = gql`
    query GetAllVkos {
  vkos {
    id
    name
    markets {
      id
      name
    }
    vkoUser {
      givenName
      id
      mail
      name
      surname
      userPrincipalName
    }
  }
}
    `;

/**
 * __useGetAllVkosQuery__
 *
 * To run a query within a React component, call `useGetAllVkosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVkosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVkosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllVkosQuery(baseOptions?: Apollo.QueryHookOptions<GetAllVkosQuery, GetAllVkosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVkosQuery, GetAllVkosQueryVariables>(GetAllVkosDocument, options);
      }
export function useGetAllVkosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVkosQuery, GetAllVkosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVkosQuery, GetAllVkosQueryVariables>(GetAllVkosDocument, options);
        }
export type GetAllVkosQueryHookResult = ReturnType<typeof useGetAllVkosQuery>;
export type GetAllVkosLazyQueryHookResult = ReturnType<typeof useGetAllVkosLazyQuery>;
export type GetAllVkosQueryResult = Apollo.QueryResult<GetAllVkosQuery, GetAllVkosQueryVariables>;
export const CreateVkoDocument = gql`
    mutation CreateVko($input: CreateVkoInput!) {
  createVko(input: $input) {
    vko {
      id
    }
  }
}
    `;
export type CreateVkoMutationFn = Apollo.MutationFunction<CreateVkoMutation, CreateVkoMutationVariables>;

/**
 * __useCreateVkoMutation__
 *
 * To run a mutation, you first call `useCreateVkoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVkoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVkoMutation, { data, loading, error }] = useCreateVkoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVkoMutation(baseOptions?: Apollo.MutationHookOptions<CreateVkoMutation, CreateVkoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVkoMutation, CreateVkoMutationVariables>(CreateVkoDocument, options);
      }
export type CreateVkoMutationHookResult = ReturnType<typeof useCreateVkoMutation>;
export type CreateVkoMutationResult = Apollo.MutationResult<CreateVkoMutation>;
export type CreateVkoMutationOptions = Apollo.BaseMutationOptions<CreateVkoMutation, CreateVkoMutationVariables>;
export const UpdateVkoDocument = gql`
    mutation UpdateVko($input: UpdateVkoInput!) {
  updateVko(input: $input) {
    vko {
      id
    }
  }
}
    `;
export type UpdateVkoMutationFn = Apollo.MutationFunction<UpdateVkoMutation, UpdateVkoMutationVariables>;

/**
 * __useUpdateVkoMutation__
 *
 * To run a mutation, you first call `useUpdateVkoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVkoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVkoMutation, { data, loading, error }] = useUpdateVkoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVkoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVkoMutation, UpdateVkoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVkoMutation, UpdateVkoMutationVariables>(UpdateVkoDocument, options);
      }
export type UpdateVkoMutationHookResult = ReturnType<typeof useUpdateVkoMutation>;
export type UpdateVkoMutationResult = Apollo.MutationResult<UpdateVkoMutation>;
export type UpdateVkoMutationOptions = Apollo.BaseMutationOptions<UpdateVkoMutation, UpdateVkoMutationVariables>;
export const DeleteVkoDocument = gql`
    mutation DeleteVko($input: DeleteVkoInput!) {
  deleteVko(input: $input) {
    vko {
      id
    }
  }
}
    `;
export type DeleteVkoMutationFn = Apollo.MutationFunction<DeleteVkoMutation, DeleteVkoMutationVariables>;

/**
 * __useDeleteVkoMutation__
 *
 * To run a mutation, you first call `useDeleteVkoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVkoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVkoMutation, { data, loading, error }] = useDeleteVkoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVkoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVkoMutation, DeleteVkoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVkoMutation, DeleteVkoMutationVariables>(DeleteVkoDocument, options);
      }
export type DeleteVkoMutationHookResult = ReturnType<typeof useDeleteVkoMutation>;
export type DeleteVkoMutationResult = Apollo.MutationResult<DeleteVkoMutation>;
export type DeleteVkoMutationOptions = Apollo.BaseMutationOptions<DeleteVkoMutation, DeleteVkoMutationVariables>;